import API from '../../../../../services/api';

export const API_ENVIOS = {
    getEnvios: async (page = null, search = null) => {
        const pagination = page !== null ? '?page=' + page : '';
        const searcher = search !== null && page !== null ? '&' + search : search !== null ? '?' + search : '';
        return await API.get('/envios' + pagination + searcher).then(res => res.data);
    },
    getEnviosData: async (search) => {
        return API.get('/envios-data?search=' + search).then(res => res.data);
    },
    getEtiqueta: async (envioId) => {
        return API.get('/envios/' + envioId + '/etiqueta', {responseType: 'blob'}).then(res => res.data);
    },
    getHermesStatus: async (numSeguimiento) => {
        return await API.get('/hermesLogistics/' + numSeguimiento + '/estado').then(res => res.data);
    },
    consumoEnviosExport: async (data) => {
        return API.post('/envios/export/consumo', data, {responseType: 'blob'}).then(res => res.data);
    },
    getEndOfDay: async (data) => {
        return API.post('/envios/export/fin-dia', data, {responseType: 'blob'}).then(res => res.data);
    },
    getInfoEnvios: async (data) => {
        return API.post('/envios-info', data).then(res => res.data);
    },
    newEnvio: async (envio) => {
        return API.post('/envios', envio).then(res => res.data);
    },
    updateEnvio: async (envio) => {
        return API.put('/envios/' + envio.id, envio).then(res => res.data);
    },
    regenerarEnvioPendiente: async (envio) => {
        return API.post('envios/regenerar/pendiente', envio).then(res => res.data);
    },
    enviarEmailProveedor: async (envioId) => {
        return API.post('envios/' + envioId + '/email').then(res => res.data);
    },
    cancelarEnvio: async (envio) => {
        return API.post('/envios/' + envio.id + '/cancelar', envio).then(res => res.data);
    }
}